// extracted by mini-css-extract-plugin
export default {"container":"ProvidedRow-container_PLekc","availabilityContainer":"ProvidedRow-availabilityContainer_vYJRX","domainProductDescription":"ProvidedRow-domainProductDescription_dKPkt"};